import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import SimpleModal from 'components/SimpleModal';
import { closeUnauthorizedModal } from 'actionCreators';
import { signOut } from 'thunk';
import { AppStateType } from 'reducers';
import { useAppDispatch } from 'redux/hooks';

const UnauthorizedModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useSelector((state: AppStateType) => state.globalReducer.isUnauthorizedModalOpen);

  const handleClose = useCallback(() => {
    dispatch(closeUnauthorizedModal());
  }, [dispatch]);

  const handleConfirm = useCallback(() => {
    // Close modal and sign out (redirects to login)
    dispatch(closeUnauthorizedModal());
    dispatch(signOut());
  }, [dispatch]);

  return (
    <SimpleModal
      open={isOpen}
      onClose={handleClose}
      headerText={
        'Please log out and log in again if you are experiencing global data loading issues.'
      }
      cancelButtonText="Ignore"
      confirmButtonText="Log out"
      onConfirm={handleConfirm}
      closeOnConfirm
      width={600}
    />
  );
};

export default UnauthorizedModal;
